module.exports = __webpack_public_path__ + "img/YO.41aca878.png";